import { PeaksInstance } from "peaks.js";
import { CaptionListProps } from "../types/caption";

export function secondsToFormattedTime(second : number) {
    const date = new Date(second * 1000);
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = date.getUTCMilliseconds().toString().padStart(3, '0');
    const time = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    return time ;
}

export function timeStringToSeconds(timeString : string) {

    if(timeString.includes('0000')) {
        console.log(`[timeStringToSeconds function] input 타입이 일치하지 않음 : ${timeString}`)
    }
    const totalMilliseconds = Date.parse(`1970-01-01T${timeString.trim().replace(",", ".").replace("000000", "000.000").replace('0000', '.000')}Z`);

    const totalSeconds = totalMilliseconds / 1000;
    if(totalSeconds == null) {
        alert("timeStringToSeconds의 변환 오류 발생")
    }
    return totalSeconds
}

export function getCurrentSegmentIdx(peaksInstance: PeaksInstance, captionArr: CaptionListProps[]) {
  const currentTime = peaksInstance.player.getCurrentTime();

  const findCurrentSegmentIdx = (caption: CaptionListProps, index: number) => {
    if (Number(caption.startTime) <= currentTime
      && Number(caption.endTime) >= currentTime) {
      return true;
    } else
      return false;
  };

  const foundSegmentIdx = captionArr.findIndex(findCurrentSegmentIdx);
  return foundSegmentIdx;
}

export function getCurrentSegment(peaksInstance: PeaksInstance, captionArr: CaptionListProps[]) {
  const currentTime = peaksInstance.player.getCurrentTime();

  const findCurrentSegment = (caption: CaptionListProps, index: number) => {
    if (Number(caption.startTime) <= currentTime 
    && Number(caption.endTime) >= currentTime) {
      return true;
    } else
      return false;
  };
  const foundSegment = captionArr.find(findCurrentSegment);
  return {currentTime, foundSegment};
}